import React from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'
import DateRangeFilter from './DateRangeFilter'
import dayjs from 'dayjs'

const DateRangeCard = ({ value, onChange, defaultDates, onResetAll, disabled = false }) => {
  const isDefaultRange =
    Array.isArray(value) &&
    Array.isArray(defaultDates) &&
    value.length === 2 &&
    defaultDates.length === 2 &&
    dayjs(value[0]).isSame(dayjs(defaultDates[0]), 'day') &&
    dayjs(value[1]).isSame(dayjs(defaultDates[1]), 'day')

  return (
    <Card elevation={0} className="date-range-card">
      <CardContent className="oc-date-range-card-content">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography className="oc-date-range-title">Periodo de análisis</Typography>

          <Box className="oc-date-range-actions">
            <Typography sx={{ mt: 1 }} variant="body2">
              Rango de fechas:
            </Typography>

            <Box className="oc-date-range-filter">
              <DateRangeFilter disabled={disabled} value={value} onChange={onChange} />
            </Box>

            {!isDefaultRange && (
              <Typography variant="body2" className="oc-date-range-reset" onClick={onResetAll}>
                Restablecer
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default DateRangeCard
